import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export const pdfFileName = (name, date = new Date()) => {
  const safe = (name || "Client").replace(/[^\w\- ]+/g, "").trim().replace(/\s+/g, "_") || "Client";
  return `FNA_${safe}_${date.toISOString().slice(0, 10)}.pdf`;
};

export const downloadPdf = async (pages, fileName) => {
  const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait", compress: true });
  for (let i = 0; i < pages.length; i += 1) {
    const canvas = await html2canvas(pages[i], { scale: 2, useCORS: true, backgroundColor: "#ffffff", windowWidth: pages[i].scrollWidth });
    if (i > 0) pdf.addPage();
    pdf.addImage(canvas.toDataURL("image/jpeg", 0.92), "JPEG", 0, 0, 210, 297);
  }
  pdf.setProperties({ title: fileName.replace(/\.pdf$/, ""), author: "Shalindra K C, ExpInsured Finance · Experior Financial Group" });
  pdf.save(fileName);
};
